export enum PreInspectionSteps {
  First,
  Second,
}
